module.exports = __webpack_public_path__ + "static/media/flour_logo.036f0715.png";